import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { BlueprintDetailPage } from "@/features/ZeroAdmin/blueprints/BlueprintDetailPage";
import {
  blueprintReviewSearchSchema,
  DEFAULT_VERSION_FILTERS,
} from "@/features/ZeroAdmin/blueprints/library";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/_zeroAdmin/blueprints/$blueprintId",
)({
  component: BlueprintDetailRoute,
  validateSearch: zodValidator(blueprintReviewSearchSchema),
  search: { middlewares: [retainSearchParams(["device"])] },
});

function BlueprintDetailRoute() {
  const { siteId, blueprintId } = Route.useParams();
  const {
    device = "mobile",
    status = DEFAULT_VERSION_FILTERS.status,
    accounts = DEFAULT_VERSION_FILTERS.accounts,
    exclude = DEFAULT_VERSION_FILTERS.exclude,
  } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BlueprintDetailPage
      siteId={siteId}
      blueprintId={blueprintId}
      device={device}
      onDeviceChange={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, device: next }),
          replace: true,
        })
      }
      filters={{ status, accounts, exclude }}
      onFiltersChange={(next) =>
        void navigate({
          // Defaults stay out of the URL.
          search: (prev) => ({
            ...prev,
            status:
              next.status === DEFAULT_VERSION_FILTERS.status
                ? undefined
                : next.status,
            accounts:
              next.accounts === DEFAULT_VERSION_FILTERS.accounts
                ? undefined
                : next.accounts,
            exclude: next.exclude.length ? next.exclude : undefined,
          }),
          replace: true,
        })
      }
    />
  );
}
